import { Link } from 'react-router-dom'
import { Alert } from '@luuna/shared'
import { ElementIntent } from '$enums'
import { AppointmentRoutePath } from '$features/appointments/routes/protected'
import { Router } from '$utils/router'

export type PendingBookingProfileBannerProps = {
  className?: string,
}

export function PendingBookingProfileBanner({ className }: PendingBookingProfileBannerProps) {
  return (
    <Alert
      intent={ElementIntent.Warning}
      className={className}
    >
      <Alert.Heading>
        Pending from online booking
      </Alert.Heading>

      <Alert.Body>
        This profile is only visible because of an appointment request. Confirm or reject the
        request on the{' '}

        <Link
          to={Router.getRoute(AppointmentRoutePath.AppointmentsRequests)}
          className="font-medium underline hover:text-yellow-900"
        >
          appointment requests
        </Link>

        {' '}
        page to add them to your directory.
      </Alert.Body>
    </Alert>
  )
}
